import { useContext } from 'react';

import { Button, ButtonGroup, Icon } from '@blueprintjs/core';
import PageContext from '../../Context/PageContext';

import $ from "jquery";

import * as htmlToImage from 'html-to-image';

import uniqid from 'uniqid';

const CadreController = () => {

  const { objItems, selectedItem, setSelectedItem, setCropCadreImage } = useContext(PageContext);

  var item = objItems.find(item => item.id === selectedItem.id);
  
  var isPushImg = false;
  if(item != null && item.cropCadre != null) isPushImg = item.cropCadre.isPushImg;

  function setCropCadre() {
    /* To set changed property to listItems*/
    const item = objItems.find(item => item.id === selectedItem.id);

    if (selectedItem != null) {

      /* Should be clone for working with different obj */
      let copyJson = { ...item };
      copyJson.id = uniqid();
      copyJson.type = "crop-cadre-element"
      //for object should be copy by clone, else it done by reference..
      let copyJsonStyle = { ...item.style };
      copyJson.style = copyJsonStyle;

      //set id of original element to define new size and transform
      copyJson.originalId = item.id

      if (setCropCadreImage != null) setCropCadreImage(copyJson);

      //to force reload of cropCadreImage
      setTimeout(() => {
        var element = document.querySelector('#' + copyJson.id);

        if (setSelectedItem != null) setSelectedItem(element)
        //hidden temporaly img => gone visible on unselect
        $("#img-" + item.id).css('visibility', 'hidden');

      }, 10);

    }
  }

  function testDownloadImgCrop() {

    const item = objItems.find(item => item.id === selectedItem.id);

    const i = document.querySelector('#' + item.id + '.cadre-element') as HTMLElement;

    //on vient temporairement set 
    objItems.forEach(async (element: any) => {
      if (element.type == "cadre-element") {
        let imgToPrint = document.querySelector('#' + element.id + '.cadre-element') as HTMLElement;
        let srcToPush = document.querySelector('#img-' + element.id) as HTMLImageElement;
        console.log(imgToPrint)
        console.log(srcToPush.src)

        //vérifier que le pixelRatio est juste
        await htmlToImage.toPng(i, { quality: 1, pixelRatio: 4 })
          .then(function (dataUrl) {
            console.log("img download")
            console.log(dataUrl)
            srcToPush.src = dataUrl;

            //temporairement à width, height à 100% et transform à 0 le temps de la génération

          }).catch(function (error) {
            console.error('oops, something went wrong!', error);
            //$('div[class*=mapboxgl-ctrl]').show();
          });
      }
    });
  }



  return (
    <div className="img-controller">
      <ButtonGroup>
        {isPushImg && <Button className='' onClick={() => setCropCadre()} icon="crop" ></Button>}
        {//<Button className='' onClick={() => testDownloadImgCrop()} icon="circle" ></Button>
        }
      </ButtonGroup>
    </div>
  );
};

export default CadreController;
